import { defineMessages } from "react-intl";

export default defineMessages({
    defaultProjectName: {
        id: "onboarding.wizard.defaultProjectName",
        defaultMessage: "My Kanban Project",
        description: "Default name for a new project if none is provided"
    },
    defaultScrumProjectName: {
        id: "onboarding.wizard.defaultScrumProjectName",
        defaultMessage: "My Scrum Project",
        description: "Default name for a new scrum project if none is provided"
    },
    defaultFirstProjectName: {
        id: "onboarding.wizard.defaultFirstProjectName",
        defaultMessage: "My First Project",
        description: "Default name for a new first project if none is provided"
    }
});
